/* Naelia: comportamiento propio (barra fija, carruseles, popup, volver arriba, comparador) */
(() => {
  const money = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'es-MX', { style: 'currency', currency: window.Shopify?.currency?.active || 'MXN' }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  };

  /* --- Puntos de carrusel (reseñas y testimonios) --- */
  const initDots = (root) => {
    const track = root.querySelector('[data-nae-track]');
    const dots = root.querySelectorAll('[data-nae-dots] button');
    if (!track || !dots.length) return;
    const slides = () => Array.from(track.children);
    dots.forEach((dot, i) => dot.addEventListener('click', () => {
      const s = slides()[i];
      if (s) track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }));
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const x = track.scrollLeft;
        let best = 0, bestD = Infinity;
        slides().forEach((s, i) => { const d = Math.abs(s.offsetLeft - track.offsetLeft - x); if (d < bestD) { bestD = d; best = i; } });
        dots.forEach((d, i) => d.setAttribute('aria-current', i === best ? 'true' : 'false'));
      });
    }, { passive: true });
  };
  document.querySelectorAll('[data-nae-review], .nae-testi').forEach(initDots);

  /* --- Barra de compra fija --- */
  document.querySelectorAll('[data-nae-sticky]').forEach((bar) => {
    const sectionId = bar.dataset.section;
    const mainBtn = document.getElementById(`ProductSubmitButton-${sectionId}`);
    const form = document.getElementById(`product-form-${sectionId}`);
    document.body.appendChild(bar);
    const show = (v) => bar.classList.toggle('is-visible', v);
    if (bar.dataset.display === 'always' || !mainBtn) {
      show(true);
    } else {
      const check = () => show(mainBtn.getBoundingClientRect().bottom < 0);
      window.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check);
      check();
    }
    bar.querySelector('[data-nae-sticky-btn]')?.addEventListener('click', () => {
      if (mainBtn && !mainBtn.disabled) mainBtn.click();
      else if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    const select = bar.querySelector('[data-nae-sticky-select]');
    const priceBox = bar.querySelector('[data-nae-sticky-price]');
    const setPrice = (price, compare) => {
      if (!priceBox) return;
      priceBox.innerHTML = `<span>${price}</span>${compare ? `<s>${compare}</s>` : ''}`;
    };
    select?.addEventListener('change', () => {
      const opt = select.selectedOptions[0];
      const idx = select.selectedIndex;
      // marcar el pack equivalente en la ficha para que Dawn cambie de variante
      const radios = document.querySelectorAll(`#variant-selects-${sectionId} input[type="radio"]`);
      if (radios[idx]) { radios[idx].checked = true; radios[idx].dispatchEvent(new Event('change', { bubbles: true })); }
      setPrice(opt.dataset.price, opt.dataset.compare);
    });
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        const v = data?.variant;
        if (!v || data.sectionId !== sectionId) return;
        setPrice(money(v.price), v.compare_at_price > v.price ? money(v.compare_at_price) : '');
        if (select) select.value = String(v.id);
      });
    }
  });

  /* --- Ventana emergente --- */
  document.querySelectorAll('[data-nae-popup]').forEach((pop) => {
    const key = 'nae-popup-' + pop.dataset.naePopup;
    let seen = false;
    try { seen = sessionStorage.getItem(key) === '1'; } catch (e) {}
    if (seen && !Shopify.designMode) return;
    const close = () => { pop.classList.remove('is-open'); try { sessionStorage.setItem(key, '1'); } catch (e) {} };
    pop.querySelectorAll('[data-nae-close]').forEach((b) => b.addEventListener('click', close));
    pop.addEventListener('click', (e) => { if (e.target === pop) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    setTimeout(() => pop.classList.add('is-open'), (parseInt(pop.dataset.delay, 10) || 5) * 1000);
  });

  /* --- Volver arriba --- */
  document.querySelectorAll('[data-nae-totop]').forEach((btn) => {
    document.body.appendChild(btn);
    const toggle = () => btn.classList.toggle('is-visible', window.scrollY > 800);
    window.addEventListener('scroll', toggle, { passive: true });
    btn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    toggle();
  });

  /* --- Comparador deslizante --- */
  document.querySelectorAll('.nae-slider-compare').forEach((box) => {
    const input = box.querySelector('input[type="range"]');
    input?.addEventListener('input', () => box.style.setProperty('--pos', input.value + '%'));
  });
})();
